export default function hasMultipleLocationSelected(rosterAreas = []) {
  const companyIds = rosterAreas?.map(x => x.Company) || [];
  return [...new Set(companyIds)]?.length === 1 ? false : true;
}
